<template>
  <div class="text-xs-center">
    <div class="text-xs-center">
      <v-avatar size="128" color="grey lighten-4" @click="onPickFile" style="cursor: pointer;">
        <v-icon color="grey lighen-4">fal fa-camera</v-icon>
      </v-avatar>
    </div>
    <div>
      <v-btn small flat @click="onPickFile" v-if="!imageUrl" class="btn-select-file">
        <v-icon left color="grey lighen-4" small>fal fa-upload</v-icon>
        {{ selectLabel }}
      </v-btn>
      <v-btn small flat color="error" @click="removeFile" class="btn-remove-file" v-else>
        {{ removeLabel }}
      </v-btn>
      <input type="file" ref="image" name="image" :accept="accept"
        @change="onFilePicked">
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {},
    accept: {
      type: String,
      default: '*'
    },
    selectLabel: {
      type: String,
      default: 'Selecionar uma foto'
    },
    removeLabel: {
      type: String,
      default: 'Remover'
    }
  },

  data () {
    return {
      imageUrl: ''
    }
  },

  watch: {
    value (v) {
      this.imageUrl = v
    }
  },

  mounted () {
    this.imageUrl = `"${this.value}"`
  },

  methods: {
    onPickFile () {
      this.$refs.image.click()
    },

    onFilePicked (event) {
      const files = event.target.files || event.dataTransfer.files

      if (files && files[0]) {
        let filename = files[0].name

        if (filename && filename.lastIndexOf('.') <= 0) {
          return alert('Imagem inválida!')
        }

        const fileReader = new FileReader()
        fileReader.addEventListener('load', () => {
          this.imageUrl = fileReader.result
        })

        fileReader.readAsDataURL(files[0])

        this.$emit('input', files[0])
      }
    },

    removeFile () {
      this.imageUrl = ''
    }
  },

  computed: {
    fileSelected () {
      return this.imageUrl && this.imageUrl !== `"undefined"` && this.imageUrl.length
    }
  }
}
</script>

<style scoped>
input[type=file] {
  position: absolute;
  left: -99999px;
}

.image-preview {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background-size: cover;
  border-radius: 50%;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/modules/PhotoUpload.vue